import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

import { COMPLIANCE_PROFILE_OPTIONS } from '../../../constants';
import type { CampaignSetupForm } from '../types';

interface ComplianceProfileFieldProps {
  form: UseFormReturn<CampaignSetupForm>;
  canWrite: boolean;
  onSelect: (value: string) => void;
}

export const ComplianceProfileField = ({
  form,
  canWrite,
  onSelect,
}: ComplianceProfileFieldProps) => {
  const { t } = useTranslation();

  return (
    <FormField
      control={form.control}
      name="complianceProfile"
      render={({ field }) => (
        <FormItem className="mt-6">
          <FormLabel>{t('campaigns.setup.compliance_profile')}</FormLabel>
          <FormControl>
            <Select
              value={field.value}
              onValueChange={(value) => {
                field.onChange(value);
                onSelect(value);
              }}
              disabled={!canWrite}
            >
              <SelectTrigger className="w-full">
                <SelectValue placeholder={t('common.select_dots')} />
              </SelectTrigger>
              <SelectContent>
                {COMPLIANCE_PROFILE_OPTIONS.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {t(option.labelKey)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </FormControl>
          <FormDescription>{t('campaigns.setup.compliance_profile_description')}</FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
